import { LineItem } from './typings';

export function isKgProductLineItem(lineItem: LineItem): boolean {
  return lineItem.properties?._is_kg_product === 'true';
}

export function getKgOriginalUnitPrice(lineItem: LineItem): number {
  return parseInt(lineItem.properties?._kg_original_unit_price || '0', 10);
}

export function getKgSavingsLineAmount(lineItem: LineItem): number {
  const originalUnitPrice = getKgOriginalUnitPrice(lineItem);
  return (originalUnitPrice - lineItem.price) * lineItem.quantity;
}
